import { takeLatest } from "redux-saga/effects";

import chatActionCreators from "../../actions/chat";
import sagasUtils from "../../../utils/sagas.utils";

export function* watchSyncReplyMessages() {
  yield takeLatest(chatActionCreators.syncReplyMessages.toString(), sagasUtils.syncMessages);
}
